// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("rescript/lib/js/string.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var DOM__Attributes$SmartcutsMacros = require("./DOM__Attributes.bs.js");

function ofElement(element) {
  var tagName = element.tagName.toLowerCase();
  var attributes = DOM__Attributes$SmartcutsMacros.ofDomElement(element);
  var attributesWithLowercaseType_type_ = OptionUtils$SmartcutsMacros.map(attributes.type_, $$String.lowercase_ascii);
  var attributesWithLowercaseType_value = attributes.value;
  var attributesWithLowercaseType_name = attributes.name;
  var attributesWithLowercaseType_title = attributes.title;
  var attributesWithLowercaseType_placeholder = attributes.placeholder;
  var attributesWithLowercaseType_selected = attributes.selected;
  var attributesWithLowercaseType_contenteditable = attributes.contenteditable;
  switch (tagName) {
    case "input" :
        var match = attributesWithLowercaseType_type_;
        if (match === undefined) {
          return Caml_option.some(element);
        }
        switch (match) {
          case "email" :
          case "password" :
          case "search" :
          case "tel" :
          case "text" :
          case "url" :
              return Caml_option.some(element);
          default:
            return ;
        }
    case "textarea" :
        return Caml_option.some(element);
    default:
      return ;
  }
}

function valueGet(inputElement) {
  var value = inputElement.value;
  var match = $$String.lowercase_ascii(inputElement.type);
  var match$1 = $$String.lowercase_ascii(value);
  switch (match) {
    case "checkbox" :
    case "radio" :
        break;
    default:
      return value;
  }
  if (match$1 === "on") {
    return ;
  } else {
    return value;
  }
}

function doesSupportSelection(htmlInputElement) {
  var tagName = htmlInputElement.tagName;
  if (tagName === "TEXTAREA") {
    return true;
  }
  if (tagName !== "INPUT") {
    return Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: element should be <textarea> or <input>, got <" + (tagName + ">"));
  }
  var type_ = htmlInputElement.type;
  switch (type_) {
    case "password" :
    case "search" :
    case "tel" :
    case "text" :
    case "url" :
        return true;
    default:
      return false;
  }
}

exports.ofElement = ofElement;
exports.valueGet = valueGet;
exports.doesSupportSelection = doesSupportSelection;
/* Util-SmartcutsMacros Not a pure module */
